import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-score",
  "use": "icon-score-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-score\">\r\n<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#5093ED\" />\r\n<path d=\"M10.5 5.5C11.0272 5.5 11.4591 5.90794 11.4973 6.42537L11.5 6.5V14.5H8.5V6.5C8.5 5.97282 8.90794 5.54092 9.42537 5.50274L9.5 5.5H10.5ZM14 8C14.5523 8 15 8.44771 15 9V13.5C15 14.0523 14.5523 14.5 14 14.5H12.5V8H14ZM7.5 9.5V14.5H6C5.44771 14.5 5 14.0523 5 13.5V10.5C5 9.9477 5.44771 9.5 6 9.5H7.5Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/score.svg
// module id = LHNj
// module chunks = 3